
// // Imports
// import andreas from "../../assets/Orators/andreas_m_papas.jpg";
// import maria from "../../assets/Orators/maria_richards_brown.jpg";
// import rassa from "../../assets/Orators/rassa_pegahi.jpg";
// import anna from "../../assets/Orators/anna_sobanska.jpg";
// import barbara from "../../assets/Orators/barbara_de_filippis.jpg";
// import priya from "../../assets/Orators/priya_hays.jpg";
// import teresa from "../../assets/Orators/teresa_carvajal.jpg";
// import huiqin from "../../assets/Orators/huiqin_yang.jpg";

// // Banner imports
// import andreas_banner from "../../assets/Orator Banners/andreas_m_papas_banner.jpg";
// import maria_banner from "../../assets/Orator Banners/maria_richards_brown_banner.jpg";
// import rassa_banner from "../../assets/Orator Banners/rassa_pegahi_banner.jpg";
// import anna_banner from "../../assets/Orator Banners/anna_sobanska_banner.jpg";
// import barbara_banner from "../../assets/Orator Banners/barbara_de_filippis_banner.jpg";
// import priya_banner from "../../assets/Orator Banners/priya_hays_banner.jpg";
// import teresa_banner from "../../assets/Orator Banners/teresa_carvajal_banner.jpg";
// import huiqin_banner from "../../assets/Orator Banners/huiqin_yang_banner.jpg";

// export const orators = [
//   {
//     id: "andreas-m-papas",
//     image: andreas,
//     name: "Dr. Andreas M Papas",
//     from: "USA",
//     about: "Adjunct Professor",
//     link: "/ICAN-orators/andreas-m-papas",
//   },
//   {
//     id: "maria-richards-brown",
//     image: maria,
//     name: "Maria Richards Brown",
//     from: "United Kingdom",
//     about: "Research Assistant",
//     link: "/ICAN-orators/maria-richards-brown",
//   },
//   {
//     id: "rassa-pegahi",
//     image: rassa,
//     name: "Dr. Rassa Pegahi",
//     from: "France",
//     about: "PhD in Molecular Biology",
//     link: "/ICAN-orators/rassa-pegahi",
//   },
//   {
//     id: "anna-w-sobanska",
//     image: anna,
//     name: "Dr. Anna W. Sobańska",
//     from: "Poland",
//     about: "PhD in Organic Chemistry",
//     link: "/ICAN-orators/anna-w-sobanska",
//   },
//   {
//     id: "barbara-de-filippis",
//     image: barbara,
//     name: "Prof. Barbara De Filippis",
//     from: "Italy",
//     about: "Associate Professor in Medicinal Chemistry, University of Chieti",
//     link: "/ICAN-orators/barbara-de-filippis",
//   },
//   {
//     id: "priya-hays",
//     image: priya,
//     name: "Dr. Priya Hays",
//     from: "USA",
//     about: "Science Writer and Author",
//     link: "/ICAN-orators/priya-hays",
//   },
//   {
//     id: "teresa-carvajal",
//     image: teresa,
//     name: "Dr. Teresa Carvajal",
//     from: "USA",
//     about: "Faculty Member at Purdue University",
//     link: "/ICAN-orators/teresa-carvajal",
//   },
//   {
//     id: "huiqin-yang",
//     image: huiqin,
//     name: "Dr. Huiqin Yang",
//     from: "United Kingdom",
//     about: "Senior Research Fellow",
//     link: "/ICAN-orators/huiqin-yang",
//   },
// ];

// // Detailed orator data

// export const andreas_m_papas_data = {
//   id: "andreas-m-papas",
//   image: andreas,
//   from: "USA",
//   name: "Dr. Andreas M Papas",
//   banner: andreas_banner,
//   about:
//     "Dr. Papas is Adjunct Professor of the College of Medicine, East Tennessee State University and CEO and member of the Board of Directors of Antares Health Products, Inc. A Fulbright Scholar and author of 'The Vitamin E Factor', he developed product concepts with NIH-supported clinical evaluation, formulation, and commercial production expertise.",
// };

// export const maria_richards_brown_data = {
//   id: "maria-richards-brown",
//   image: maria,
//   from: "United Kingdom",
//   name: "Maria Richards Brown",
//   banner: maria_banner,
//   about:
//     "Maria Richards-Brown is a research assistant at UCL, with a background in Experimental Psychology from Oxford and MSc in Clinical Mental Health Sciences. She worked on pharmacogenetics studies focusing on patient and clinician feedback regarding antipsychotic drug reactions.",
// };

// export const rassa_pegahi_data = {
//   id: "rassa-pegahi",
//   image: rassa,
//   from: "France",
//   name: "Dr. Rassa Pegahi",
//   banner: rassa_banner,
//   about:
//     "Dr. Pegahi earned a PhD in Molecular Biology and has 7 years of oncology experience in hospital and pharmaceutical industry, specializing in medical affairs and clinical trials.",
// };

// export const anna_w_sobanska_data = {
//   id: "anna-w-sobanska",
//   image: anna,
//   from: "Poland",
//   name: "Dr. Anna W. Sobańska",
//   banner: anna_banner,
//   about:
//     "Dr. Sobańska earned a PhD in Organic Chemistry from Oxford and has worked as a formulation chemist at Pollena-Ewa Cosmetic Factory in Poland.",
// };

// export const barbara_de_filippis_data = {
//   id: "barbara-de-filippis",
//   image: barbara,
//   from: "Italy",
//   name: "Prof. Barbara De Filippis",
//   banner: barbara_banner,
//   about:
//     "Prof. De Filippis is Associate Professor in Medicinal Chemistry at the University of Chieti, focusing on small molecule anticancer and antimicrobial research.",
// };

// export const priya_hays_data = {
//   id: "priya-hays",
//   image: priya,
//   from: "USA",
//   name: "Dr. Priya Hays",
//   banner: priya_banner,
//   about:
//     "Dr. Hays is an accomplished science writer with over twenty publications and five books, serving also as a guest editor on cancer immunotherapies.",
// };

// export const teresa_carvajal_data = {
//   id: "teresa-carvajal",
//   image: teresa,
//   from: "USA",
//   name: "Dr. Teresa Carvajal",
//   banner: teresa_banner,
//   about:
//     "Dr. Carvajal is faculty at Purdue University with a focus on material sciences impacting pharmaceutical formulations and manufacturing.",
// };

// export const huiqin_yang_data = {
//   id: "huiqin-yang",
//   image: huiqin,
//   from: "United Kingdom",
//   name: "Dr. Huiqin Yang",
//   banner: huiqin_banner,
//   about:
//     "Dr. Yang is Senior Research Fellow in Health Technology Assessment at University of Exeter with extensive HTA experience for NICE and NIHR programs.",
// };

// // Map for lookup

// export const orators_details_map = {
//   "andreas-m-papas": andreas_m_papas_data,
//   "maria-richards-brown": maria_richards_brown_data,
//   "rassa-pegahi": rassa_pegahi_data,
//   "anna-w-sobanska": anna_w_sobanska_data,
//   "barbara-de-filippis": barbara_de_filippis_data,
//   "priya-hays": priya_hays_data,
//   "teresa-carvajal": teresa_carvajal_data,
//   "huiqin-yang": huiqin_yang_data,
// };


// Imports
import alsu from "../../assets/Orators/Alsu_Zagorulko.jpg";
import elita from "../../assets/Orators/Elita_Delbruck.jpg";
import esraa from "../../assets/Orators/Esraa_Askar.jpg";
import flavia from "../../assets/Orators/Flavia_I_Spiroiu.jpg";
import fulya from "../../assets/Orators/Fulya_Turker.jpg";
import geetanjali from "../../assets/Orators/Geetanjali_Rathore.jpg";
import marina from "../../assets/Orators/Marina_Martinez_Vargas.jpg";
import michelle from "../../assets/Orators/Michelle_Herman.jpg";
import rebecca from "../../assets/Orators/Rebecca_Lees.jpg";
import ryane from "../../assets/Orators/Ryane_Elizabeth_Adams.jpg";

// Banner imports
import alsu_banner from "../../assets/Orator Banners/Alsu_Zagorulko_banner.jpg";
import elita_banner from "../../assets/Orator Banners/Elita_Delbruck_banner.jpg";
import esraa_banner from "../../assets/Orator Banners/Esraa_Askar_banner.jpg";
import flavia_banner from "../../assets/Orator Banners/Flavia_I_Spiroiu_banner.jpg";
import fulya_banner from "../../assets/Orator Banners/Fulya_Turker_banner.jpg";
import geetanjali_banner from "../../assets/Orator Banners/Geetanjali_Rathore_banner.jpg";
import marina_banner from "../../assets/Orator Banners/Marina_Martinez_Vargas_banner.jpg";
import michelle_banner from "../../assets/Orator Banners/Michelle_Herman_banner.jpg";
import rebecca_banner from "../../assets/Orator Banners/Rebecca_Lees_banner.jpg";
import ryane_banner from "../../assets/Orator Banners/Ryane_Elizabeth_Adams_banner.jpg";


export const orators = [
  {
    id: "fulya-turker",
    image: fulya,
    name: "Fulya Turker",
    from: "USA",
    about: "Johns Hopkins University",
    link: "/ICAN-orators/fulya-turker",
  },
  {
    id: "alsu-zagorulko",
    image: alsu,
    name: "Dr. Alsu Zagorulko",
    from: "USA",
    about: "Neurology, Illinois Center",
    link: "/ICAN-orators/alsu-zagorulko",
  },
  {
    id: "marina-martinez-vargas",
    image: marina,
    name: "Dr. Marina Martinez Vargas",
    from: "USA",
    about: "Baylor College",
    link: "/ICAN-orators/marina-martinez-vargas",
  },
  {
    id: "rebecca-lees",
    image: rebecca,
    name: "Rebecca Lees",
    from: "USA",
    about: "Guthrie, Penn State",
    link: "/ICAN-orators/rebecca-lees",
  },
  {
    id: "geetanjali-rathore",
    image: geetanjali,
    name: "Dr. Geetanjali Rathore",
    from: "USA",
    about: "Univ. of Nebraska",
    link: "/ICAN-orators/geetanjali-rathore",
  },
  {
    id: "flavia-spiroiu",
    image: flavia,
    name: "Flavia I. Spiroiu",
    from: "Canada",
    about: "McMaster University",
    link: "/ICAN-orators/flavia-spiroiu",
  },
  {
    id: "elita-delbruck",
    image: elita,
    name: "Elita Delbruck",
    from: "USA",
    about: "CUSM, California",
    link: "/ICAN-orators/elita-delbruck",
  },
  {
    id: "michelle-herman",
    image: michelle,
    name: "Michelle Herman",
    from: "USA",
    about: "Patient Advocate",
    link: "/ICAN-orators/michelle-herman",
  },
  {
    id: "esraa-askar",
    image: esraa,
    name: "Dr. Esraa Askar",
    from: "USA",
    about: "Northwell/Hofstra",
    link: "/ICAN-orators/esraa-askar",
  },
  {
    id: "ryane-adams",
    image: ryane,
    name: "Ryane Elizabeth Adams",
    from: "USA",
    about: "McGovern Medical School",
    link: "/ICAN-orators/ryane-adams",
  },
];

// Detailed orator data

export const fulya_turker_data = {
  id: "fulya-turker",
  image: fulya,
  from: "USA",
  name: "Fulya Turker",
  banner: fulya_banner,
  about:
    "Fulya Turker studied Molecular Biology and Genetics at Sabanci University, Turkey, and graduated with a BS in 2017. She then joined the research group of Prof. Seth S. Margolis at the Department of Biological Chemistry, Johns Hopkins University School of Medicine. She is in her final year of PhD study on protein degradation in the nervous system.",
};

export const alsu_zagorulko_data = {
  id: "alsu-zagorulko",
  image: alsu,
  from: "USA",
  name: "Dr. Alsu Zagorulko",
  banner: alsu_banner,
  about:
    "Dr. Alsu Zagorulko studied Medicine at Russian National Research Medical University, named after N.I. Pirogov, Moscow, Russia, and graduated as M.D. in 2017. She then began preparation for USMLE Steps to be able to practice Medicine in the United States. She moved there in 2019, passed USMLE Steps, and acquired an ECFMG certificate in 2021. She is interested in Psychiatry and currently rotating in mental health hospitals and clinics around the States. At the same time, she’s doing research in Neurology and Psychiatry. She is applying for the Psychiatry Residency this year.",
};

export const marina_martinez_vargas_data = {
  id: "marina-martinez-vargas",
  image: marina,
  from: "USA",
  name: "Dr. Marina Martinez Vargas",
  banner: marina_banner,
  about:
    "Dr. Marina Martinez-Vargas received her BS in Microbiology at the University of Puerto Rico (UPR), Humacao Campus. Then, she received her PhD in Biochemistry at UPR, Medical Sciences Campus. She is currently a Postdoctoral Fellow in Neuroscience and Thrombosis at Baylor College of Medicine. She has 6 peer review publications. Her research interests are focused on Traumatic Brain Injury. She is applying for a Career Development Award from the Department of Veteran Affairs. She is proposing to address novel molecular mechanisms associated with Blood-Brain Barrier (BBB) damage and testing potential reagents capable of improving BBB integrity after TBI.",
};

export const rebecca_lees_data = {
  id: "rebecca-lees",
  image: rebecca,
  from: "USA",
  name: "Rebecca Lees",
  banner: rebecca_banner,
  about:
    "Rebecca Lees studied psychology with a neuroscience focus at the Pennsylvania State University and graduated with a BS in 2017. She then became an Intramural Research Training Award fellow at the National Institutes of Health/National Eye Institute, working with Dr. Tudor Badea to research the influence of retinal ganglion cell development on visually-evoked behaviors in mice. In 2019, she began her journey as a medical student at Geisinger Commonwealth School of Medicine and is expected to graduate in 2023.",
};

export const elita_delbruck_data = {
  id: "elita-delbruck",
  image: elita,
  from: "USA",
  name: "Elita Delbruck",
  banner: elita_banner,
  about:
    "Elita Delbruck studied Cognitive Neuroscience at the University of California, Irvine where she joined the Visual Perception and Neuroimaging Lab in the School of Social Sciences and later also joined the Vawter Lab in the Department of Psychiatry and Human Behavior. She graduated with a Bachelor of Science and several honors awards in 2017. She began medical school at the California University of Science and Medicine in 2019, where she is currently in her last year of pursuing her MD and a residency training program in neurology. She has multiple research publications in neuroscience and aspires to continue her career in clinical neurology research.",
};

export const michelle_herman_data = {
  id: "michelle-herman",
  image: michelle,
  from: "USA",
  name: "Michelle Herman",
  banner: michelle_banner,
  about:
    "Michelle Herman is a charismatic and engaging award-winning Public Speaker and Communications professional with an undeniable passion for showing compassion and empathy to others. Michelle’s medical journey in her early 30’s consisted of a TIA being misdiagnosed, leading to a major stroke and eventually a Moya Moya disease diagnosis, a lifesaving brain surgery and chronic depression. Michelle openly shares her story and struggles with the medical community, to give insight to the patient experience.",
};

export const esraa_askar_data = {
  id: "esraa-askar",
  image: esraa,
  from: "USA",
  name: "Dr. Esraa Askar",
  banner: esraa_banner,
  about:
    "Dr. Askar graduated medical school at Faculty of Medicine, Alexandria University, Egypt in 2016. She then worked as a teaching assistant at Microbiology and Immunology Department Faculty of Medicine, Alexandria University for 2 years, during which she finished her USMLE exams and then joined the Internal Medicine Residency training program at Department of Internal Medicine, Northwell/Hofstra Zucker School of Medicine, Long Island Jewish Forest Hills, NY, USA. She was honored to be the intern of the year during her first year of residency 2020-2021. She then was chosen by her program to be the chief resident during her third year of residency 2022-2023. Throughout her medical school, she was a member of “Future Doctor Society” which is a non-governmental organization in Egypt aiming to improve the health care system. She participated in many fundraising projects, campaigns, and social events.",
};

export const ryane_adams_data = {
  id: "ryane-adams",
  image: ryane,
  from: "USA",
  name: "Ryane Elizabeth Adams",
  banner: ryane_banner,
  about:
    "Ryane Adams studied Biology at Xavier University of Louisiana in New Orleans, Louisiana and graduated in 2018. She is currently a 4th year medical student at the University of Texas at Houston Health and Science Center located in the Texas Medical Center. She is applying to Physical Medical and Rehabilitation this application cycle with the hopes of becoming an academic physiatrist with a focus in neurorehabilitation and spasticity.",
};

export const geetanjali_rathore_data = {
  id: "geetanjali-rathore",
  image: geetanjali,
  from: "USA",
  name: "Dr. Geetanjali Rathore",
  banner: geetanjali_banner,
  about:
    "Dr. Rathore is an associate professor of Pediatrics and Neurosciences at University of Nebraska Medical Center, Omaha, Nebraska, USA. She completed medical school from Sampurnanad Medical School in India and completed her Pediatric Neurology Training in Child Neurology from Baylor college of Medicine and Texas Childrens Hospital, Houston, USA in 2015. Dr. Rathore has an experience of treating patients with Pediatric Autoimmune encephalitis for over 10 years and has published many abstracts, articles and book chapters in the field of Neuroimmunology. She has presented her work at many national and international meetings and is considered an international expert in the condition.",
};

export const flavia_spiroiu_data = {
  id: "flavia-spiroiu",
  image: flavia,
  from: "Canada",
  name: "Flavia I Spiroiu",
  banner: flavia_banner,
  about:
    "Flavia Spiroiu obtained her Bachelor of Arts in Psychology at Ryerson University in Toronto, Canada. Ms. Spiroiu subsequently earned her Master of Arts in Clinical Psychology from Lakehead University in Thunder Bay, Canada. She is currently conducting her Ph.D. in Clinical and Health Neuroscience at McMaster University and the Anxiety Treatment and Research Centre in Hamilton, Canada under the supervision of Dr. Noam Soreni. Miss Spiroiu’s research examines the cognitive and behavioral mechanisms of transcranial direct current stimulation (tDCS) in the context of cognitive behavioral therapy (CBT) and exposure and response prevention (ERP) for obsessive-compulsive disorder (OCD).",
};
// Map for lookup

export const orators_details_map = {
  "fulya-turker": fulya_turker_data,
  "alsu-zagorulko": alsu_zagorulko_data,
  "marina-martinez-vargas": marina_martinez_vargas_data,
  "rebecca-lees": rebecca_lees_data,
  "elita-delbruck": elita_delbruck_data,
  "michelle-herman": michelle_herman_data,
  "esraa-askar": esraa_askar_data,
  "ryane-adams": ryane_adams_data,
  "geetanjali-rathore": geetanjali_rathore_data,
"flavia-spiroiu": flavia_spiroiu_data,
};